import { render, staticRenderFns } from "./Marcas-de-productos.vue?vue&type=template&id=93a4232c"
import script from "./Marcas-de-productos.vue?vue&type=script&lang=js"
export * from "./Marcas-de-productos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports